export default "__VITE_ASSET__GGmtzfYB__"